import { Component } from '@theme/component';

/**
 * @typedef {Object} CollectionSeoRefs
 * @property {HTMLButtonElement[]} tabs
 * @property {HTMLElement[]} panels
 */

/**
 * Tabs for the Collection SEO section.
 *
 * @extends {Component<CollectionSeoRefs>}
 */
class CollectionSeoComponent extends Component {
  /** @type {number} */
  #active = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#updateActiveTab();
  }

  /**
   * @param {Event} event
   */
  selectTab = (event) => {
    const tab = event.target;
    const tabs = this.refs.tabs;

    if (!(tab instanceof HTMLButtonElement) || !tabs) return;

    const index = tabs.indexOf(tab);
    if (index === -1) return;

    this.#active = index;
    this.#updateActiveTab();
  };

  #updateActiveTab() {
    const { tabs, panels } = this.refs;

    for (const [index, tab] of (tabs ?? []).entries()) {
      const isActive = index === this.#active;
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    }

    for (const [index, panel] of (panels ?? []).entries()) {
      const isActive = index === this.#active;
      panel.toggleAttribute('hidden', !isActive);
      panel.toggleAttribute('inert', !isActive);
    }
  }
}

if (!customElements.get('collection-seo-component')) {
  customElements.define('collection-seo-component', CollectionSeoComponent);
}
